<mat-form-field appearance="standard" class="input-form">
  <mat-label translate>{{ label }} </mat-label>
  <input
    #input
    matInput
    class="input"
    [formControl]="control"
    [attr.inputmode]="inputMode"
    [attr.type]="type"
    placeholder="{{ placeholder }}"
    [maxLength]="maxLength || 256"
    disableRipple
  />
  <div matSuffix *ngIf="icon" class="icon icon-{{ icon }}"></div>
  <mat-hint *ngIf="maxLength">{{ control.value?.length || 0 }}/{{ maxLength }}</mat-hint>
  <mat-error *ngIf="error">
    {{ error }}
  </mat-error>
  <button
    *ngIf="clearButton"
    mat-button
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="handleClearClick()"
    disableRipple
    class="clear-button"
    type="button"
  >
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
